import { render } from "./EditEventForm.vue?vue&type=template&id=6c255c34&scoped=true"
import script from "./EditEventForm.vue?vue&type=script&lang=js"
export * from "./EditEventForm.vue?vue&type=script&lang=js"

import "./EditEventForm.vue?vue&type=style&index=0&id=6c255c34&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c255c34"]])

export default __exports__